
document.addEventListener("DOMContentLoaded", function () {
  const CSbody = document.querySelector("body");
  const CSheader = document.querySelector("#cs-navigation");         // <header id="cs-navigation">
  const CSnav = document.querySelector("#cs-navigation .cs-nav");    // <nav class="cs-nav">
  const CShamburgerMenu = document.querySelector("#cs-navigation .cs-toggle");
  const csUL = document.querySelector("#cs-expanded");

  // Säkerhet: om något saknas, gör inget (så det inte kraschar)
  if (!CSbody || !CSheader || !CSnav || !CShamburgerMenu || !csUL) {
    return;
  }

  // Öppna/stäng mobilmenyn
  CShamburgerMenu.addEventListener("click", function () {
    CShamburgerMenu.classList.toggle("cs-active");
    CSheader.classList.toggle("cs-active");
    CSnav.classList.toggle("cs-active");              // <- NYTT: toggla även på <nav>
    CSbody.classList.toggle("cs-open");

    // aria-expanded för ul
    const expanded = csUL.getAttribute("aria-expanded") === "true";
    csUL.setAttribute("aria-expanded", expanded ? "false" : "true");
  });

  // Scroll–klass på body (för skugga / bakgrund på nav)
  document.addEventListener("scroll", () => {
    const scroll = document.documentElement.scrollTop;
    CSbody.classList.toggle("scroll", scroll >= 100);
  });

  // Dropdowns – funkar i mobil, stör inte länkar
  const dropDowns = Array.from(
    document.querySelectorAll("#cs-navigation .cs-dropdown")
  );

  for (const item of dropDowns) {
    const onClick = (e) => {
      // Om man klickar direkt på en länk, låt länken göra sitt jobb
      if (e.target.closest("a")) return;
      item.classList.toggle("cs-active");
    };
    item.addEventListener("click", onClick);
  }
});
